import type { Web3Library } from './walletContext'
import { ROUTER_ADDRESS } from '../../constants'

const DEFAULT_BLOCK_SCAN = 40

/** Busca una tx reciente del usuario hacia el router (recarga en MetaMask antes de persistir hash). */
export async function findRecentRouterTransactionHash(
  library: Web3Library,
  account: string,
  notBeforeMs: number,
  maxBlocks = DEFAULT_BLOCK_SCAN,
  options?: { excludeHashes?: string[] },
): Promise<string | null> {
  const router = ROUTER_ADDRESS.toLowerCase()
  const from = account.toLowerCase()
  const excluded = new Set((options?.excludeHashes ?? []).map((hash) => hash.toLowerCase()))
  const latestBlock = await library.getBlockNumber()
  const notBeforeSec = Math.floor(notBeforeMs / 1000)

  for (let offset = 0; offset < maxBlocks; offset++) {
    const blockNumber = latestBlock - offset
    if (blockNumber < 0) break

    const block = await library.getBlockWithTransactions(blockNumber)
    if (!block) continue
    if (block.timestamp < notBeforeSec) break

    for (const tx of block.transactions) {
      if (!tx.from || !tx.to || !tx.hash) continue
      if (tx.from.toLowerCase() !== from) continue
      if (tx.to.toLowerCase() !== router) continue
      if (excluded.has(tx.hash.toLowerCase())) continue
      return tx.hash
    }
  }

  return null
}
